import OrderSource from "@/api/OrderSource.js";

export const orderModule = {
    state: () => ({
        isLoadingTotals: null,
        isLoadingOrderAdd: false,
        errorOrder: null,
        errorListOrder: null,
        totals: [],
    }),
    mutations: {
        setTotals(state, data) {
            state.totals = [...data];
        },

        clearOrderErrors(state) {
            state.errorOrder = null;
            state.errorListOrder = null;
        },

    },
    getters: {},
    actions: {
        async updateTotals({state, commit}) {
            try {
                state.isLoadingTotals = true;
                await this.$API.manager.getSource(OrderSource).totals().then(async (response) => {
                    await commit('setTotals', response.totals);
                }).catch(() => {
                    commit('setProducts', []);
                }).finally(() => {
                    state.isLoadingTotals = false;
                })
            } finally {
                state.isLoadingTotals = false;
            }
        },
        async addOrder({state, commit, dispatch}, data) {

            state.isLoadingOrderAdd = true;
            state.errorOrder = null;
            state.errorListOrder = null;
            commit('shipping/resetFormErrors', null, {root: true});

            try {
                const response = await this.$API.manager.getSource(OrderSource).add(data);

                if(response.order_id){
                    localStorage.setItem('sendOrderToYandexOnSuccessPay', response.order_id)
                    window._tmr?.push({ type: 'reachGoal', id: response.order_id, goal: 'Покупка пиксель'});
                }

                if (response.payment_link) {
                    return window.location.href = response.payment_link;
                }
                dispatch('cart/load', {}, {root: true});
                return window.location.href = window.location.origin + '/order/detail/' + response.order_id

            } catch (error) {
                if (error?.response?.data?.error) {
                    state.errorOrder = error?.response?.data?.error;
                }

if (error?.response?.data?.errors) {
                     if (error?.response?.data?.errors?.shipping_address) {
                         commit('shipping/setFormErrors', {
                             shipping_address: error.response?.data?.errors?.shipping_address
                         }, {root: true})
                         delete error.response?.data?.errors?.shipping_address;
                     }
                     state.errorListOrder = error?.response?.data?.errors;
                 }
            } finally {
                state.isLoadingOrderAdd = false;
                document.querySelectorAll('.invalid-text')?.[0]?.scrollIntoView({
                    block: "center",
                    behavior: "smooth"
                });
            }
        },
        sendYandexEcommerceOrder({}, orderData) {
            const products = orderData.products.map((product, index) => ({
                id: product.product_id,
                name: product.name,
                price: parseFloat(product.order.total),
                brand: "Краснодарский парень",
                category: product.category_id,
                quantity: parseInt(product.order.quantity),
                position: index + 1,
            }));

            window?.dataLayer?.push({
                ecommerce: {
                    currencyCode: "RUB",
                    purchase: {
                        actionField: {
                            id: orderData.order_id.toString(),
                        },
                        products: products,
                    },
                },
            });
        }
    },



    namespaced: true
}
